import { ModifiedCodeMappings, CodeMappingsListItems } from './types-store';

export const compareCodeMappingIds = (modified: ModifiedCodeMappings, persisted: CodeMappingsListItems) =>
  modified.id === persisted.id &&
  !!persisted.codetable && persisted.codetable.value === modified.codetable;

export const getModifiedItem = (modifiedItems: ModifiedCodeMappings[], persistedItem: CodeMappingsListItems) =>
  !modifiedItems || !persistedItem
    ? undefined
    : modifiedItems.find(
      modifiedItem => compareCodeMappingIds(modifiedItem, persistedItem)
    );

export const findModifiedItem = (modifiedItems: ModifiedCodeMappings[], modifiedItem: ModifiedCodeMappings) =>
  !modifiedItems || !modifiedItem
    ? undefined
    : modifiedItems.find(item =>
      item.id === modifiedItem.id &&
      item.codetable === modifiedItem.codetable
    );

export const updatePersistedItem = (
  persistedItems: CodeMappingsListItems,
  modifiedItem: ModifiedCodeMappings
): CodeMappingsListItems =>
  modifiedItem
    ? {
      ...(persistedItems || {} as CodeMappingsListItems),
      description: modifiedItem.description?.trim(),
      code: modifiedItem.code,
      codeCategory: modifiedItem.codeCategory
    }
    : persistedItems;
